import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Frame from '../../../../../../shared/components/Frame';
import theme from '../../../../../../styles/theme';
import Text from './components/Text';

function CardTotal() {
  const clientsContext = useSelector((reducer: IReducer) => reducer.clientsApp);

  const totalBalanceState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.clientsList.totalBalance
  );

  return (
    <Frame.Default
      isActive={clientsContext.gotSuccess && clientsContext.isActive}
      color="white"
      margin="0.5rem 0 1rem 0"
      padding="0.5rem 0 0 0"
      width="100%"
      justifyContent="center"
      backgroundColor={theme.colors.mainColor}>
      <Text.Value>
        {totalBalanceState.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        })}
      </Text.Value>
    </Frame.Default>
  );
}

export default CardTotal;
